module.exports = __webpack_public_path__ + "img/style_swiper_02_active.6d33053d.png";